import React from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
  // Navigate
  const navigate = useNavigate();

  return (
    <footer className="bg-black pt-6 text-white md:pt-16">
      {/* Heading and email address container*/}
      <div className="mb-12 block px-4 pt-6 xl:hidden">
        {/* Heading */}
        <h1 className="mb-4 text-center font-bold uppercase">
          Sign up for exclusive team everlast news & offers
        </h1>
        {/* Email address heading and forward icon container */}
        <div className="relative flex max-w-3xl items-center justify-center md:mx-auto">
          <input
            required
            type="email"
            placeholder="Enter email address"
            className="w-full rounded border border-none px-2 py-3 text-black outline-none"
          />
          <img
            src="/icons/next.png"
            alt="Forward icon"
            className="absolute right-2 h-4 w-4"
          />
        </div>
      </div>
      {/* Footer content container */}
      <div className="gap-x-8 px-6 text-xl md:grid md:grid-cols-[1fr_1fr_2fr] md:text-sm lg:grid-cols-[auto_1fr_1fr_3fr] lg:gap-x-16 xl:grid-cols-[auto_auto_auto_2fr_2fr] 2xl:px-20">
        {/* Noya athletic logo */}
        <img
          src="/logo/logo-white.png"
          alt="Noya athletic"
          className="hidden h-20 cursor-pointer lg:block"
          onClick={() => navigate("/")}
        />
        {/* Get help container */}
        <div className="mb-12">
          {/* Get help heading */}
          <h1 className="mb-8 font-bold uppercase">Get help</h1>
          {/* Get help options container */}
          <div className="flex flex-col gap-4 capitalize">
            <span className="cursor-pointer hover:underline">Order Status</span>
            <span className="cursor-pointer hover:underline">
              Shipping And Delivery
            </span>
            <span className="cursor-pointer hover:underline">Returns</span>
            <span className="cursor-pointer hover:underline">Warranty</span>
            <span className="cursor-pointer hover:underline">Size Charts</span>
            <span className="cursor-pointer hover:underline">
              Order Cancellation
            </span>
            <span className="cursor-pointer hover:underline">
              Payment Options
            </span>
            <span className="cursor-pointer hover:underline">Gift Cards</span>
            <span className="cursor-pointer hover:underline">Help Center</span>
          </div>
        </div>
        {/* About noya athletic container */}
        <div className="mb-12">
          {/* About noya athletic heading */}
          <h1 className="mb-8 font-bold uppercase">About noya athletic</h1>
          {/* Get help options container */}
          <div className="flex flex-col gap-4 capitalize">
            <span className="cursor-pointer hover:underline">
              About Noya Athletic
            </span>
            <span className="cursor-pointer hover:underline">News</span>
            <span className="cursor-pointer hover:underline">Careers</span>
            <span className="cursor-pointer hover:underline">
              Privacy Policy
            </span>
            <span className="cursor-pointer hover:underline">Disclaimer</span>
            <span className="cursor-pointer hover:underline">
              GSA Information
            </span>
          </div>
        </div>

        {/* Heading and email address container */}
        <div className="mb-12 hidden px-4 pt-6 xl:block">
          {/* Heading */}
          <h1 className="mb-4 text-center font-bold uppercase">
            Sign up for exclusive team everlast news & offers
          </h1>
          {/* Email address heading and forward icon container */}
          <div className="relative flex items-center justify-center md:mx-auto">
            <input
              required
              type="email"
              placeholder="Enter email address"
              className="w-full rounded border border-none px-2 py-3 text-black outline-none"
            />
            <img
              src="/icons/next.png"
              alt="Forward icon"
              className="absolute right-2 h-4 w-4"
            />
          </div>
        </div>

        {/* Social media icons container */}
        <div className="mb-4 flex items-center justify-between gap-12 md:items-start md:justify-end md:gap-4 md:pt-4">
          {/* Instagram icon */}
          <div className="cursor-pointer transition-all hover:scale-105">
            <ion-icon name="logo-instagram" size="large"></ion-icon>
          </div>
          {/* Facebook icon */}
          <div className="cursor-pointer transition-all hover:scale-105">
            <ion-icon name="logo-facebook" size="large"></ion-icon>
          </div>
          {/* Twitter icon */}
          <div className="cursor-pointer transition-all hover:scale-105">
            <ion-icon name="logo-twitter" size="large"></ion-icon>
          </div>
        </div>
        {/* Copyright text */}
        <p className="md:text-md pb-12 uppercase md:col-start-3 md:px-0 md:text-end lg:col-start-4 xl:col-start-5">
          © 2024 noya athletic worldwise inc.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
